import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedFilter: [],
  activityFilter: null as any,
  deviceFilter: null as any,
  cityFilter: null as any,
  filterCount: {
    appOpenValue: "1",
    appOperateValue: "1",
    appNotOpenValue: "1",
    appNotOperateValue: "1",
    sceneCount: "1",
    sceneRunCount: "1",
    automationCount: "1",
    automationRunCount: "1",
  },
};

export const AnalyticsResponseSlice = createSlice({
  name: "AnalyticsResponse",
  initialState,
  reducers: {
    getSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
    setActivityFilter: (state, action) => {
      state.activityFilter = action.payload;
    },
    setDeviceFilter: (state, action) => {
      state.deviceFilter = action.payload;
    },
    setCityFilter: (state, action) => {
      state.cityFilter = action.payload;
    },
    getFilterCount: (state, action) => {
      state.filterCount = {
        ...state.filterCount,
        ...action.payload,
      };
    },
  },
});

export const {
  getSelectedFilter,
  setActivityFilter,
  setDeviceFilter,
  setCityFilter,
  getFilterCount,
} = AnalyticsResponseSlice.actions;

export default AnalyticsResponseSlice.reducer;
